
import React, { useState, useEffect } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import { SignInProvider } from './services/contexts/SignInContext';
import { SignUpProvider } from './services/contexts/SignUpContext';
import Dashboard from './Dashboard';
import SignInForm from './SignInForm';
import Sidebar from './Sidebar';
import Header from './Header';
import CustomerList from './CustomersList';
import ItemForm from './ItemForm';
import ItemsList from './ItemsList';
import MediaUpload from './MediaUpload';
import CorporateOrderList from './OrdersList';
import EventOrderList from './EventOrderList';
import Categories from './Categories';
import PaymentList from './Payment';
import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import Undeliveredorders from './Undeliveredorders';
import Purchase from './Purchase'
import Stock from './Stock';
import CreateCoupon from './CreateCoupon';


const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_ADMIN_API_URL}/graphql`, // GraphQL endpoint
});


const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token'); // Retrieve token from localStorage
  return {
    headers: {
      ...headers,
      token: token || '', // Add the token to the 'token' header
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});



// Create Apollo Client
// const client = new ApolloClient({
//   uri: 'https://dev.caterorange.com/graphql', // Replace with your actual GraphQL endpoint
//   cache: new InMemoryCache(),
//   headers:{token:localStorage.getItem('token')}
// });


function App() {
  return (
    <ApolloProvider client={client}>
      <SignInProvider>
        <SignUpProvider>
          <Router>
            <AppContent />
          </Router>
        </SignUpProvider>
      </SignInProvider>
    </ApolloProvider>
  );
}

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setUser({ token });
    }
    setLoading(false);
  }, []);

  const handleSignIn = (token) => {
    if (token) {
      setUser({ token });
    }
  };

  const handleSignOut = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const AuthenticatedLayout = ({ children }) => (
    <div className="flex h-screen overflow-hidden">
      <Sidebar className="w-64 flex-shrink-0 h-full overflow-y-auto" />
      <div className="flex flex-col flex-grow">
        <Header className="flex-shrink-0" onSignOut={handleSignOut} />
        <main className="flex-grow overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <SignInForm onSignIn={handleSignIn} />
        }
      />
      <Route
        path="/dashboard"
        element={
          user ? (
            <AuthenticatedLayout>
              <Dashboard />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/customerslist"
        element={
          user ? (
            <AuthenticatedLayout>
              <CustomerList />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/itemslist"
        element={
          user ? (
            <AuthenticatedLayout>
              <ItemsList />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/itemadd"
        element={
          user ? (
            <AuthenticatedLayout>
              <ItemForm />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />

      <Route
        path="/addmedia"
        element={
          user ? (
            <AuthenticatedLayout>
              <MediaUpload />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/orderslist"
        element={
          user ? (
            <AuthenticatedLayout>
              <EventOrderList />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />

      <Route
        path="/undeliveredorders"
        element={
          user ? (
            <AuthenticatedLayout>
              <Undeliveredorders />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/paymentlist"
        element={
          user ? (
            <AuthenticatedLayout>
              <PaymentList />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/purchase"
        element={
          user ? (
            <AuthenticatedLayout>
              <Purchase />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/stock"
        element={
          user ? (
            <AuthenticatedLayout>
              <Stock />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/Createcoupon"
        element={
          user ? (
            <AuthenticatedLayout>
              <CreateCoupon />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
      <Route
        path="/categories"
        element={
          user ? (
            <AuthenticatedLayout>
              <Categories />
            </AuthenticatedLayout>
          ) : (
            <Navigate to="/" state={{ from: location }} replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
